/**
 * Which Klarity service a client is on. A label a person sets by hand: nothing in the platform decides by it.
 * The names are those of the CIPP tenant groups; Docs neither reads nor writes a tenant's group.
 */
export type ClientTier = "secure" | "managed" | "core" | "freebp" | "free";

/**
 * The one list: its order is the order of the sections on the Clients page. The check `spaces_tier_check`
 * (migration 0007) holds the same five keys; a test compares them.
 */
export const CLIENT_TIERS: readonly { key: ClientTier; label: string }[] = [
  { key: "secure", label: "Secure Workspace" },
  { key: "managed", label: "Managed Workspace" },
  { key: "core", label: "Core Workspace" },
  { key: "freebp", label: "FreeBP Baseline" },
  { key: "free", label: "Free Baseline" },
];

/** The heading, and the select's option, for a client without a tier. */
export const UNCATEGORIZED_LABEL = "Uncategorized";

export const isClientTier = (value: unknown): value is ClientTier => CLIENT_TIERS.some((t) => t.key === value);

export const clientTierLabel = (tier: ClientTier | null): string =>
  CLIENT_TIERS.find((t) => t.key === tier)?.label ?? UNCATEGORIZED_LABEL;
